import React from 'react'
import RawDropdownPicker from './dropdown'
import {LegacyDatePicker} from './legacy_date_picker'
import BaseInput from './input'
import {buildField, makeLegacyField} from '@eitje/form'
import utils from '@eitje/utils'
import _ from 'lodash'

const _withIcon = props => !props.selectAll

const defaultDropdownValue = props => {
	if (props.multiple) return []
	return null
}

const getDropdownPickerClassName = props => {
	return utils.makeCns('eitje-dropdown-container', props.multiple && 'eitje-dropdown-container-multiple')
}

const DropdownPicker = buildField(RawDropdownPicker, {
	className: getDropdownPickerClassName,
	withClearIcon: _withIcon,
	withIcon: _withIcon,
	defaultPickerValue: defaultDropdownValue,
})

const LegacyDropdownPicker = makeLegacyField(RawDropdownPicker, {className: 'eitje-dropdown-container'})

const getInputProps = props => {
	const className = utils.makeCns(
		'eitje-input-container',
		props.textarea && 'eitje-input-container-textarea',
		props.password && 'eitje-input-container-password',
	)

	return {className, icon: false, withClearIcon: true, clearIcon: true}
}

let Input = buildField(BaseInput, getInputProps)
Input = React.memo(Input, _.isEqual)
Input.defaultProps = {defaultSubmitStrategy: 'blur'}

const LegacyInput = makeLegacyField(BaseInput, {className: 'eitje-input-container'})
LegacyInput.defaultProps = {defaultSubmitStrategy: 'blur'}

const LegacyFormDatePickerField = makeLegacyField(LegacyDatePicker, {className: 'eitje-legacy-date-picker-container'})

export {
	DropdownPicker,
	LegacyDropdownPicker,
	Input,
	BaseInput,
	LegacyInput,
	// (Antd) Date picker field for legacy form
	LegacyFormDatePickerField,
}
